import { useRef, useState } from "react";

import { fileApi } from "src/1/apis/file.api";

import { IconUpload } from "./Icons";

export const UploadZone = ({ append }) => {
  //#region Data
  const fileInputRef = useRef(null);

  const [uploading, setUploading] = useState(false);
  //#endregion

  //#region Event
  const onFilesChange = async (event) => {
    const filesList = event.target.files;
    if (!filesList || filesList.length === 0) return;
    setUploading(true);

    const files = Array.from(filesList);

    for (const file of files) {
      try {
        const res = await fileApi.upload(file);
        append(res.data.data);
      } catch (error) {
        noti("error", error?.message || "Lỗi không xác định khi xử lý file");
      }
    }

    fileInputRef.current.value = ""; // Reset input
    setUploading(false);
  };
  //#endregion

  //#region Render
  return (
    <div
      className={`relative group bg-[#f7f7f7] hover:border-blue-400 border-gray-300 border-2 border-dashed rounded-xl p-3 transition-all cursor-pointer flex flex-col items-center justify-center gap-1 ${
        uploading ? "pointer-events-none opacity-70" : ""
      }`}
      onClick={() => !uploading && fileInputRef.current?.click()}
    >
      <input
        type="file"
        className="hidden"
        multiple
        accept="image/jpeg,image/png,image/webp"
        ref={fileInputRef}
        onChange={onFilesChange}
        disabled={uploading}
      />

      <>
        <div className="p-2 flex items-center justify-center rounded-full transition-all duration-300 group-hover:scale-110">
          {uploading ? (
            <div className=" translate-y-1/2">
              <div className="w-8 h-8 border-4 border-blue-700 border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : (
            <IconUpload size={32} />
          )}
        </div>

        <div className="text-center flex flex-col">
          <span className="mb-2 text-sm font-semibold text-gray-700">
            {uploading ? "Đang tải lên..." : "Bấm để upload ảnh"}
          </span>
          <span className="text-xs text-gray-700 font-medium uppercase tracking-wider">
            {uploading
              ? "Vui lòng không đóng trang"
              : "Dung lượng tối đa 200Mb"}
          </span>
        </div>
      </>
    </div>
  );
  //#endregion
};
